module.exports = __webpack_public_path__ + "static/media/new_ar.c2c502f8.png";